import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_blogs = () => {
  return instance.get(`/v1/mngr/blogs`, { headers });
};

export const post_blogs = (data) => {
  return instance.post(`/v1/mngr/blogs`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const put_blogs = (data) => {
  return instance.put(`/v1/mngr/blogs`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const delete_blogs = (id) => {
  return instance.delete(`/v1/mngr/blogs/${id}`, { headers });
};
